import React, { useEffect, useState } from 'react'
import { Button, PRIMARY_BUTTON, Tooltip } from '@mds/mds-reactjs-library'

const DISABLED_GENERATE_TOOLTIP = 'Select at least one datapoint from each category below.'

const ApplySection = ({ selections, onGenerate }) => {

  const [disableGenerateButton, setDisableGenerateButton] = useState(true);

  useEffect(() => {
      if (!selections || selections?.some(selection => !selection.Attributes || selection.Attributes.length === 0)) {
        setDisableGenerateButton(true)
      }
      else if(selections && selections?.some(selection => selection.Attributes && selection.Attributes.length !== 0))
      {
        setDisableGenerateButton(false)
      }
  
      }, [selections]);

  const button = (
    <Button
      appearance={PRIMARY_BUTTON}
      style={{ width: '100%' }}
      onClick={onGenerate}
      disabled={disableGenerateButton}
    >
      Generate
    </Button>
  )

  return (
    <div className="apply-section">
      {disableGenerateButton ? (
        <Tooltip dark={false} content={DISABLED_GENERATE_TOOLTIP} placement="top">
          <span className="apply-generate-tooltip-anchor" style={{ display: 'block', width: '100%' }}>
            {button}
          </span>
        </Tooltip>
      ) : (
        button
      )}
      {/* <br></br>
      <p>Click "Generate" to add it your Library and generate data.</p> */}
    </div>
  )
}

export default ApplySection
